module.exports = __webpack_public_path__ + "img/7.c3a203a0.png";